import styled from "@xstyled/styled-components";

export const List = styled.ul`
  margin: 0px;
  padding-left: 8px;
  list-style: inside;
`;
